import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { Select } from 'antd';
import { CaretDownOutlined } from '@ant-design/icons';
import './NormSelectDropdown.css';

import commonConfig from '../../../commonConfig.json';
import * as actions from '../../../../store/actions/indexes';

const { Option } = Select;

let dropDownConfigs = commonConfig.dropdownProps;

const NormSelectDropdown = props => {
    const [allOptions, setAllOptions] = useState([]);
    const [currentOptions, setCurrentOptions] = useState([]);
    const [initSelectedData, setInitSelectedData] = useState("");
    const [selectedData, setSelectedData] = useState("");
    const [drpdwnOpen, setDrpdwnOpen] = useState(false);

    const dispatch = useDispatch();

    const isControlledFiltersOpen = useSelector((state) => state.controlledComponentsReducer.isControlledFiltersOpen, shallowEqual);

    const onChange = (value, label, extra) => {
        setSelectedData(value);
        if (props.apply === dropDownConfigs.apply.ONCHANGE) { // if prop.apply is onchange - do search data update direct without any apply btn
            let additionalData = "";
            props.callback({
                key: props.indexName,
                selectedOption: value,
                valuesType: props.indexValType,
                type: props.indexType,
                indexCategory: props.indexCategory,
                additionalData: additionalData,
                actualApply: true
            });
        }
        return;
    }

    const onDrpDwnOpenClose = (e) => {
        if (e) {
            let copyOfFilterStates = JSON.parse(JSON.stringify(isControlledFiltersOpen));
            for (const key in copyOfFilterStates) {
                    copyOfFilterStates[key] = false;
            }
            dispatch(actions.setControlledFiltersOpen(copyOfFilterStates));
        }
    }
    useEffect(() => {
        setAllOptions(props.options);
        setCurrentOptions(props.options);
        //   return () => {} //cleanup  
    }, [props.options]);

    useEffect(() => {
        setSelectedData(props.selectedOptions);
        setInitSelectedData(props.selectedOptions)
        //   return () => {} //cleanup  
    }, [props.selectedOptions]);

    return (
        props.options.length !== 0 ?
        <Select
            // labelInValue
            // mode={props.mode === 'multiple' ? 'multiple' : ''}
            disabled={props.disabled}
            // defaultValue={initSelectedData}
            value={selectedData}
            placeholder={props.placeholder}
            showSearch={props.showSearch}
            onChange={onChange}
            onDropdownVisibleChange={onDrpDwnOpenClose}
            style={{ width: '100%' }}
            key={props.key}
            suffixIcon={<CaretDownOutlined className="ant-select-suffix" />}
        >
            {currentOptions.map(option => {
                return (
                    <Option key={option.key} value={option.value} >
                        {option.value}
                    </Option>
                );
            })}
        </Select>
        : <></>
    );
}

export default React.memo(NormSelectDropdown);